import { z } from 'zod';
import { msg } from '@/lib/forms/messages';
import { maxCodePoints } from '@/lib/forms/primitives';

// Mirrors Pydantic caps in api/routes/cad.py: cad_measured_mm ge=0 (:273), measurement_method
// 500 (:274), rationale 2000 (:276), assignee 200 (:277), comment 4000 (:289). Pydantic len()
// counts code points → maxCodePoints, not Zod's UTF-16 .max(). Caps check the RAW value
// (saveReview submits state as-is; no .trim()). Remaining fields are fixed inputs — no rules.
const regionReviewSchema = z.object({
  cadMeasuredMm: z
    .number(msg('cad.thickness.review.measurementNonNegative'))
    .min(0, msg('cad.thickness.review.measurementNonNegative'))
    .nullable(),
  measurementMethod: z.string().check(maxCodePoints(500, 'validation.maxLength')),
  rationale: z.string().check(maxCodePoints(2000, 'validation.maxLength')),
  assignee: z.string().check(maxCodePoints(200, 'validation.maxLength')),
});

export const thicknessReviewSchema = z.object({
  comment: z.string().check(maxCodePoints(4000, 'validation.maxLength')),
  regionReviews: z.record(z.string(), regionReviewSchema),
});
